import React from 'react';
import s from './styles.module.css'
import Wrapper from "../../components/wrapper";
import HeaderTitle from "../../components/header_title";

const Advice = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Råd til låntagere</h1>
        <p>
          At optage et lån er en vigtig økonomisk beslutning. Før du sender en ansøgning,
          er det en god idé at sammenligne flere tilbud og vurdere, om lånet passer til din økonomi.
          Her finder du en række enkle råd, der kan hjælpe dig med at træffe en velovervejet beslutning.
        </p>

        <h2>Sammenlign flere långivere</h2>
        <p>
          Lånevilkår kan variere fra udbyder til udbyder. Sammenlign derfor flere muligheder,
          før du vælger et lån. Det giver et bedre overblik over markedet og hjælper dig med
          at finde en løsning, der passer til dine behov.
        </p>

        <h2>Send gerne flere ansøgninger</h2>
        <p>
          For at øge dine chancer for at få et tilbud kan det være en fordel at sende
          ansøgninger til mindst to långivere. Forskellige udbydere vurderer ansøgninger
          ud fra forskellige kriterier.
        </p>

        <h2>Lån kun det nødvendige beløb</h2>
        <p>
          Det kan være fristende at låne mere end nødvendigt, men et mindre lån er som regel
          lettere at tilbagebetale. Overvej derfor nøje, hvor meget du faktisk har brug for.
        </p>

        <h2>Vurder din økonomi</h2>
        <p>
          Inden du optager et lån, bør du gennemgå dit budget. Sørg for, at de månedlige
          afdrag passer ind i din økonomi, så du undgår unødigt økonomisk pres.
        </p>

        <h2>Læs vilkår og betingelser</h2>
        <p>
          Læs altid låneaftalen grundigt, før du accepterer et tilbud. Vær særligt opmærksom
          på tilbagebetalingsperioden, eventuelle gebyrer og andre vilkår.
        </p>

        <h2>Betal til tiden</h2>
        <p>
          Rettidige betalinger hjælper dig med at undgå ekstra omkostninger og gør det lettere
          at bevare en sund privatøkonomi.
        </p>

        <h2>Lån ansvarligt</h2>
        <p>
          Et lån bør være en løsning på et konkret behov – ikke en langsigtet løsning på
          økonomiske problemer. Overvej altid, om du har mulighed for at tilbagebetale lånet
          inden for den aftalte periode.
        </p>
      </Wrapper>
    </div>
  );
};

export default Advice;
